import script from "./HistoryAddToCartConfirm1Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryAddToCartConfirm1Modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__